import AssessmentsPage from "./AssessmentsPage";

export default AssessmentsPage;